<template>
  <div class="admin-shop-detail" v-loading="loading">
    <div class="admin-shop-detail__body">
      <page-title title="店铺状态">
        <template slot="title">
          <span v-show="auditLogList.length" class="action" @click="showVertifyLog">
            查看认证审核记录
          </span>
          <span v-show="haltSaleRecords.length" class="action" @click="showHaltSaleRecords">
            查看违规下架记录
          </span>
        </template>
        <div class="form-item">
          <span class="form-item-label">店铺审核状态：</span>
          <div class="form-item-content w-500" v-if="shopData.id">
            <shop-state-label :status="shopData.state"></shop-state-label>
            <span class="suffix" v-if="AUTHENTICATION_FAILED"> （原因：{{ shopData.audits.opinion || '- -' }} ） </span>
            <span class="suffix" v-if="VIOLATION_HALT_SALE"> （原因：{{ shopData.haltSaleRecord.cause || '- -' }} ） </span>
            <span class="suffix" v-if="VIOLATION_HALT_FAILED"> （原因：{{ shopData.audits.opinion || '- -' }} ） </span>
            <span class="suffix" v-if="DESTROYED"> （原因：店铺已注销 ） </span>
          </div>
          <span class="form-item-label">店铺会员：</span>
          <div class="form-item-content">
            {{ shopMembersTotal }}人，
            <span class="action-text" @click="openStoreMembers">查看详情</span>
          </div>
        </div>
      </page-title>
      <page-title title="基本信息">
        <shop-info :shopData="shopData" :ENTERPRISE="ENTERPRISE" :OPENED="OPENED"></shop-info>
      </page-title>
      <page-title title="认证信息">
        <shop-vertify :vertifyData="vertifyData" :ENTERPRISE="ENTERPRISE" :shopData="shopData"></shop-vertify>
        <div class="btn-grp" v-if="shopData.state === 'CERTIFIED' && shopData.type === 'ENTERPRISE'">
          <el-button v-if="shopData.batchUpload" @click="cancelBatchUpload">取消批量上传功能</el-button>
          <el-button v-else @click="openBatchUpload">开通批量上传功能</el-button>
        </div>
      </page-title>
      <shop-order v-if="OPENED" :shopStatistics="shopStatistics"></shop-order>
    </div>
    <div class="btn-grp">
      <template v-if="WAITING || VIOLATION_HALT_WAITING">
        <el-button @click="vertifyPass">审核通过</el-button>
        <el-button @click="vertifyFail">审核不通过</el-button>
      </template>
      <el-button v-if="OPENED && CERTIFIED" @click="halt">违规下架</el-button>
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="dialogTitle === '审核不通过'" width="700px">
      <!-- 认证审核记录 -->
      <div v-if="dialogTitle === '认证审核记录'" class="vertify-log-list">
        <template v-for="(i, k) in auditLogList">
          <time-line :key="i.id" :timestamp="i.createdDate" context="用户提交审核"></time-line>
          <time-line
            :finished="k === auditLogList.length - 1"
            :key="i.id"
            v-if="i.pass"
            :timestamp="i.timestamp"
            context="审核通过。"
            :addon="formatterAuditor(i.userInfo)"
          ></time-line>
          <time-line
            :finished="k === auditLogList.length - 1"
            :key="i.id"
            v-else
            :timestamp="i.timestamp"
            :context="`审核未通过，原因：${i.opinion}。`"
            :addon="formatterAuditor(i.userInfo)"
          ></time-line>
        </template>
      </div>
      <!-- 违规下架记录 -->
      <div v-else-if="dialogTitle === '违规下架记录'" class="vertify-log-list">
        <time-line
          v-for="(i, k) in haltSaleRecords"
          :key="i.id"
          :timestamp="i.violationHaltSaleTime"
          :context="`下架原因：${i.cause || '无'}`"
          :finished="k === haltSaleRecords.length - 1"
        ></time-line>
      </div>
      <!-- 审核不通过 -->
      <template v-else-if="dialogTitle === '审核不通过'">
        <el-form label-width="120px">
          <el-form-item label="审核不通过原因:">
            <el-input v-model="opinion" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <!-- 违规下架 -->
      <div v-else-if="dialogTitle === '违规下架'">
        <el-form label-width="120px">
          <el-form-item label="违规下架原因:">
            <el-input v-model="cause" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template v-else-if="dialogTitle === '查看详情'">
        <el-table ref="shopMembersTable" :data="shopMembers" row-key="id" v-loading="loading">
          <el-table-column align="center" type="index" width="50" />
          <el-table-column sortable property="nickName" label="会员昵称" width="160" show-overflow-tooltip />
          <el-table-column sortable property="phone" label="手机号" width="145">
            <template slot-scope="{ row }">
              <router-link class="action-text" :to="`/users/${row.oauthUserId}/${row.createdBy}/info`">
                <span> {{ row.phone }}，查看 </span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column sortable property="region" label="所在地区" width="155" show-overflow-tooltip />
          <el-table-column sortable property="dateTime" label="加入会员时间" />
        </el-table>
        <cus-pagination
          :sizes="false"
          :total="shopMembersTotal"
          :current-page.sync="shopMembersPage"
          :page-size.sync="shopMembersSize"
        ></cus-pagination>
      </template>
      <span class="btn-grp dialog-footer" slot="footer">
        <el-button v-if="dialogTitle === '审核不通过'" @click="comfirmVertifyFail">确定</el-button>
        <el-button v-if="dialogTitle === '违规下架'" @click="comfirmHalt">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageTitle from '@/components/pageTitle.vue';
import shopInfo from '@/views/shop/components/info';
import shopVertify from '@/views/shop/components/vertify';
import shopOrder from '@/views/shop/components/order';
import CusPagination from '@/components/cusPagination.vue';
import {
  getShopById,
  getShopStatisticsById,
  getUserBySubId,
  haltShopById,
  auditShopById,
  reAuditShopById,
  getStoreMembersList,
  openBatchUpload,
  closeBatchUpload
  // getShopAssetsById
} from '@/api/req';
import timeLine from '@/components/timeLine';
import shopStateLabel from '@/views/shop/components/shopStateLabel';
import { SHOP_STATE } from './eum';

export default {
  components: { pageTitle, shopInfo, shopVertify, shopOrder, timeLine, shopStateLabel, CusPagination },
  name: 'shopDetail',
  data() {
    return {
      loading: false,
      shopData: {},
      dialogVisible: false,
      cause: '',
      opinion: '',
      vertifyData: {},
      shopStatistics: {},
      dialogTitle: '',
      auditLogList: [],
      shopMembersTotal: 0,
      shopMembersSize: 7,
      shopMembersPage: 1,
      shopMembers: []
    };
  },
  watch: {
    shopMembersPage() {
      this.loading = true;
      this.getMembers()
        .then(res => {
          this.shopMembers = res.rows || [];
          this.shopMembersTotal = res.total || 0;
          this.shopMembersPage = res.pageNumber + 1 || 0;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  computed: {
    storeId() {
      return this.$route.params.id || 0;
    },
    userId() {
      return this.$route.params.subId || '';
    },
    WAITING() {
      // return true
      return this.shopData.state === 'WAITING';
    },
    AUTHENTICATION_FAILED() {
      return this.shopData.state === 'AUTHENTICATION_FAILED';
    },
    VIOLATION_HALT_SALE() {
      return this.shopData.state === 'VIOLATION_HALT_SALE';
    },
    VIOLATION_HALT_FAILED() {
      return this.shopData.state === 'VIOLATION_HALT_FAILED';
    },
    VIOLATION_HALT_WAITING() {
      return this.shopData.state === 'VIOLATION_HALT_WAITING';
    },
    CERTIFIED() {
      return this.shopData.state === 'CERTIFIED';
    },
    DESTROYED() {
      return this.shopData.state === 'DESTROYED';
    },
    /**
     * 是否开启店铺的标志位
     */
    OPENED() {
      return this.shopData.state && this.shopData.state !== SHOP_STATE.AUTHENTICATION_FAILED && this.shopData.state !== SHOP_STATE.WAITING;
    },
    /**
     * 该店铺是否为个人店铺
     */
    PERSONAL() {
      return this.shopData.type === 'PERSONAL';
    },
    ENTERPRISE() {
      return this.shopData && this.shopData.type === 'ENTERPRISE';
    },
    /**
     * 店铺的违规下架记录
     */
    haltSaleRecords() {
      return this.shopData.haltSaleRecords || [];
    }
  },
  methods: {
    async getData() {
      try {
        const { data } = await this.$ajax.get(getShopById(this.storeId));
        return Object.freeze(data);
      } catch (error) {
        console.log('error :>> ', error);
        this.$message.info('获取店铺认证信息失败');
        return {};
      }
    },
    async getShopStatistics() {
      try {
        const { data } = await this.$ajax.get(getShopStatisticsById(this.storeId));
        return Object.freeze(data);
      } catch (error) {
        console.log('error.data :>> ', error);
        this.$message.info('获取店铺统计信息失败');
        return {};
      }
    },
    async getUserVertify() {
      try {
        const { data } = await this.$ajax.get(getUserBySubId(this.userId));
        return Object.freeze(data);
      } catch (error) {
        console.log('error.data :>> ', error.data);
        this.$message.info('获取用户认证信息失败');
        return {};
      }
    },
    async getShopAuditLog() {
      try {
        const { data } = await this.$ajax.get(auditShopById(this.storeId));
        return data;
      } catch (error) {
        console.log('error.data :>> ', error.data);
        this.$message.info('获取用户认证记录失败');
        return [];
      }
    },
    async getMembers() {
      const { storeId, shopMembersSize: pageSize, shopMembersPage: pageNumber } = this;
      try {
        const { data } = await this.$ajax.get(getStoreMembersList, { storeId, pageSize, pageNumber });
        return data;
      } catch (err) {
        console.log(err);
        this.$message.info('加载店铺会员出错！');
        return [];
      }
    },
    showVertifyLog() {
      this.dialogTitle = '认证审核记录';
      this.dialogVisible = true;
    },
    vertifyPass() {
      const { opinion, storeId, WAITING } = this;
      const req = { pass: true, opinion, storeId };
      let reqUrl = '';
      if (WAITING) reqUrl = auditShopById(storeId);
      else reqUrl = reAuditShopById(storeId);
      this.$confirm('此操作将通过该店铺的审核请求, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      })
        .then(() => {
          this.$ajax
            .post(reqUrl, req)
            .then(async _ => {
              this.$message.success('审核成功');
              this.dialogVisible = false;
              this.shopData = await this.getData();
            })
            .catch(err => {
              console.log('err :>> ', err);
              this.$message.info('审核失败');
            });
        })
        .catch(_ => console.log(_));
    },
    vertifyFail() {
      this.dialogTitle = '审核不通过';
      this.dialogVisible = true;
    },
    comfirmVertifyFail() {
      const { opinion, storeId, WAITING } = this;
      const req = { pass: false, opinion, storeId };
      if (!opinion) {
        this.$message.info('审核不通过原因不能为空');
        return;
      }
      let reqUrl = '';
      if (WAITING) reqUrl = auditShopById(storeId);
      else reqUrl = reAuditShopById(storeId);
      this.$ajax
        .post(reqUrl, req)
        .then(async _ => {
          this.$message.success('审核成功');
          this.dialogVisible = false;
          this.shopData = await this.getData();
        })
        .catch(err => {
          console.log('err :>> ', err);
          this.$message.info('审核失败');
        });
    },
    halt() {
      this.dialogTitle = '违规下架';
      this.dialogVisible = true;
    },
    comfirmHalt() {
      const { cause } = this;
      if (cause) {
        this.$ajax
          .put(haltShopById(this.storeId), { cause })
          .then(async _ => {
            this.$message.success('下架成功');
            this.dialogVisible = false;
            this.shopData = await this.getData();
          })
          .catch(err => {
            console.log('err :>> ', err);
            this.$message.info('下架失败');
          });
      } else {
        this.$message.info('请填写违规下架原因');
      }
    },
    showHaltSaleRecords() {
      this.dialogTitle = '违规下架记录';
      this.dialogVisible = true;
    },
    openStoreMembers() {
      this.dialogTitle = '查看详情';
      this.dialogVisible = true;
    },
    async init() {
      this.loading = true;
      Promise.all([this.getData(), this.getShopStatistics(), this.getUserVertify(), this.getShopAuditLog(), this.getMembers()])
        .then(([shopData, shopStatistics, vertifyData, auditLogList, members]) => {
          this.shopData = shopData || {};
          this.shopStatistics = shopStatistics || {};
          this.vertifyData = vertifyData || {};
          this.auditLogList = auditLogList || [];
          this.shopMembers = members.rows || [];
          this.shopMembersTotal = members.total || 0;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message.info('数据加载失败！');
        });
      // this.shopData = await this.getData();
      // this.shopStatistics = await this.getShopStatistics();
      // this.vertifyData = await this.getUserVertify(); //需要依赖于shopData中的字段
      // this.auditLogList = await this.getShopAuditLog();
      // const members = await this.getMembers();
      // this.shopMembers = members.rows;
      // this.shopMembersTotal = members.total;
      // this.loading = false;
    },
    openBatchUpload() {
      this.$ajax
        .put(openBatchUpload(this.storeId))
        .then(async res => {
          this.shopData = await this.getData();
          this.$message({
            message: '开通成功',
            type: 'success'
          });
        })
        .catch(err => {
          this.$message.info('开通失败');
        });
    },
    cancelBatchUpload() {
      this.$ajax
        .put(closeBatchUpload(this.storeId))
        .then(async res => {
          this.shopData = await this.getData();
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
        })
        .catch(err => {
          this.$message.info('关闭失败');
        });
    },
    formatterAuditor(userinfo) {
      if (!userinfo) return '';
      let auditorName = '';
      if (userinfo.state === 'CERTIFIED') {
        switch (userinfo.type) {
          case 'ENTERPRISE':
            auditorName = userinfo.legalPerson;
            break;
          case 'PERSONAL':
            auditorName = userinfo.realName;
            break;
          default:
            auditorName = userinfo.nickname;
            break;
        }
      }
      return `审核员：${auditorName || userinfo.nickname}`;
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss">
.admin-shop-detail {
  ul,
  li {
    list-style: none;
  }
  .vertify-log-list {
    // padding-right: 20px;
    padding-left: 80px;
  }
  &__header {
    background-color: white;
    display: flex;
    align-items: center;
    padding: 25px 20px;
    border-radius: 4px;
    .menu-item {
      margin-right: 40px;
      height: 20px;
      font-size: 12px;
      line-height: 20px;
      a {
        text-decoration: none;
        color: #8998a0;
      }
      .chosen-one {
        font-size: 14px;
        color: #040b28;
        font-weight: bold;
      }
    }
  }
  &__body {
    margin-top: 16px;
    .action {
      color: #005bff;
      font-size: 14px;
      cursor: pointer;
      margin-left: 16px;
      font-weight: normal;
    }
    .form-item {
      margin-top: 20px;
      display: flex;
      .w-500 {
        width: 500px;
      }
      &:first-child {
        margin-top: 0;
      }
      &-label {
        height: 20px;
        font-size: 12px;
        font-weight: 500;
        color: #8998a0;
        line-height: 20px;
        margin-right: 6px;
      }
      &-content {
        font-size: 14px;
        font-weight: 400;
        color: #040b28;
        line-height: 20px;
        padding-right: 24px;
        .icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        img {
          height: 94px;
          width: 94px;
          border-radius: 4px;
          font-size: 0;
          vertical-align: bottom;
        }
        .identify-card {
          margin-right: 12px;
          height: 118px;
          width: 188px;
          &:last-child {
            margin-right: 0;
          }
        }
        .el-icon-circle {
          margin-right: 8px;
          color: #fff;
          vertical-align: middle;
        }
        .el-switch {
          height: 20px;
        }
        .suffix {
          color: #8998a0;
          font-weight: 400;
          height: 20px;
          line-height: 20px;
          margin-left: 8px;
        }
      }
    }
  }
  .btn-grp {
    padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .action-text {
    color: #005bff;
    cursor: pointer;
  }
  .el-table {
    border: 1px solid #e3e3e4;
    border-bottom: none;
    border-radius: 4px;
    font-size: 12px;
    width: 100%;
    margin-bottom: 12px;
    th {
      background-color: #fbfbfe !important;
      font-weight: 400;
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
}
</style>
